<template>
    <div>
        <el-table
            v-if="isLoading === false"
            :data="tableData"
            style="width: 100%"
            class="fresh-seed-bag-table"
            size="mini"
            :header-cell-style="{ background: '#F5F7FA' }"
            border
        >
            <el-table-column
                type="index"
                width="30"
            />
            <el-table-column
                prop="code"
                label="Progeny Code"
                min-width="85"
            />
            <el-table-column
                prop="crossType.code"
                label="Cross Type"
                min-width="75"
            />
            <el-table-column
                prop="maternalPalmId"
                label="Maternal Palm"
                min-width="75"
            />
            <el-table-column
                prop="paternalPalmId"
                label="Paternal Palm"
                min-width="75"
            />
        </el-table>
        <p v-else>Loading...</p>
    </div>
</template>

<script>
export default {
    props: {
        progenyList: {
            type: Array
        }
    },
    data() {
        return {
            tableData: [],
            isLoading: false,
        };
    },
    watch: {
        progenyList: {
            immediate: true,
            handler() {
                this.tableData = this.progenyList;
            },
        },
        isLoading() {
            if (this.isLoading === true) {
                this.tableData = [];
            }
        }
    },
    methods: {
    },
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/GerminationBatch/GerminationBatchProgenySimpleTable.vue